// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => ((chunkId === 8792 ? "main" : chunkId) + ".min.js");